import { render, staticRenderFns } from "./LeftCard.vue?vue&type=template&id=8652ece0"
import script from "./LeftCard.vue?vue&type=script&lang=js"
export * from "./LeftCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports